<object [data]="(pdfUrl$ | async)" type="application/pdf" width="100%" height="100%">

</object>
